module.exports = __webpack_public_path__ + "img/plant_1.8bb9809b.webp";